import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './page/HomePage';
import './App.css';
import { Header, ScrollToTop, Footer } from 'components';
import Blurb from './page/Blurb';
import ServiceContent from './page/ServiceContent';
import Contact from './page/Contact';
import ProductCenter from './page/ProductCenter';
import Construction from './page/Construction';
import Intelligence from './page/Intelligence';
import News from './page/News';
import NewsDetail from './page/News/detail';
import ProductDetail from './page/ProductCenter/detail';
import NotFound from './page/NotFound';
import QueueAnim from 'rc-queue-anim';

const App = () => {
  return (
    <Router>
      <>
        <ScrollToTop />
        <Header />
        <QueueAnim type={['bottom', 'top']}>
          <div key='app'>
            <Switch>
              {/* 首页 */}
              <Route exact path='/' component={HomePage} />
              {/* 关于之阳 */}
              <Route path='/blurb' component={Blurb} />
              {/* 产品详情 - 使用动态路由参数 */}
              <Route path='/productCenter/:id' component={ProductDetail} />
              {/* 产品中心 */}
              <Route path='/productCenter' component={ProductCenter} />
              {/* 服务内容 */}
              <Route path='/servicesContent' component={ServiceContent} />
              {/* 实验室建设 */}
              <Route path='/construction' component={Construction} />
              {/* 数智化实验室 */}
              <Route path='/intelligence' component={Intelligence} />
              {/* 新闻详情 - 使用动态路由参数 */}
              <Route path='/news/:id' component={NewsDetail} />
              {/* 新闻动态 */}
              <Route path='/news' component={News} />
              {/* 联系我们 */}
              <Route path='/contact' component={Contact} />
              {/* 404页面 - 必须放在最后 */}
              <Route component={NotFound} />
            </Switch>
          </div>
          <QueueAnim
            type={'bottom'}
            animConfig={[{ opacity: [1, 0] }]}
            delay={3000}
          >
            <div key='footer'>
              <Footer />
            </div>
          </QueueAnim>
        </QueueAnim>
      </>
    </Router>
  );
};

export default App;
